import React from "react";
import { Users, Info } from "lucide-react";

/**
 * Total Participant Slots Section Component
 * For Trade Missions only - allows setting total participant slots
 */
const TotalParticipantSlotsSection = ({ value = "", onChange, className = "" }) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Only allow positive integers
    if (inputValue === "" || /^\d+$/.test(inputValue)) {
      onChange(inputValue);
    }
  };

  return (
    <div className={className}>
      <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm sm:rounded-2xl">
        <div className="flex items-center mb-4 space-x-2">
          <Users className="w-5 h-5 text-purple-600" />
          <h3 className="text-lg font-bold text-gray-900">
            Total Participant Slots
          </h3>
          <span className="px-2 py-0.5 text-xs font-semibold text-purple-700 bg-purple-100 rounded-full">
            Required
          </span>
        </div>

        <div className="p-3 mb-4 bg-blue-50 rounded-lg border border-blue-200">
          <div className="flex items-start space-x-2">
            <Info className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-xs text-blue-800">
              <p className="font-semibold">Trade Mission Participant Slots</p>
              <p className="mt-0.5">
                Specify the maximum number of participants allowed for this trade mission.
                This helps manage capacity and ensure quality interactions.
              </p>
            </div>
          </div>
        </div>

        <div>
          <label className="block mb-1.5 text-xs font-semibold text-gray-700">
            Total Participant Slots <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <Users className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 -translate-y-1/2" />
            <input
              type="text"
              inputMode="numeric"
              value={value}
              onChange={handleChange}
              placeholder="e.g., 50, 100, 200"
              className="w-full pl-11 pr-3 py-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all bg-gray-50 focus:bg-white"
            />
          </div>
          <p className="mt-2 text-xs text-gray-500">
            Enter the maximum number of participants for this trade mission
          </p>
        </div>
      </div>
    </div>
  );
};

export default TotalParticipantSlotsSection;

